import { Grid, styled, Tooltip } from "@mui/material";
import { SamplingTargetFormData } from "components/Admin/Organizations/types/SamplingTargetFormData.type";
import { SamplingTargetTimePeriod } from "components/Admin/Organizations/types/SamplingTargetTimePeriod";
import { SamplingTargetUnitOfMeasure } from "components/Admin/Organizations/types/SamplingTargetUnitOfMeasure";
import { Tier } from "components/Admin/Organizations/types/Tier.type";
import AcxInputLabel from "components/UI/AcxInputLabel";
import { observer } from "mobx-react";
import React from "react";
import { OrganizationServiceHierarchyStore } from "../stores/OrganizationServiceHierarchyStore";

interface SamplingTargetLabeledMetricsProps {
    tier: Tier;
    osmStore: OrganizationServiceHierarchyStore;
}


const LabelContainerGrid = styled(Grid)(() => ({
    padding: "0.25rem",
}));

const SamplingTargetLabeledMetrics: React.FC<React.PropsWithChildren<React.PropsWithChildren<SamplingTargetLabeledMetricsProps>>> =
    observer(({ tier, osmStore }) => {
        const samplingTarget = tier.samplingTarget;

        const formattedSamplingTarget: SamplingTargetFormData = {
            id: tier.id,
            timePeriod: samplingTarget?.timePeriod
                ? SamplingTargetTimePeriod[samplingTarget.timePeriod]
                : "",
            unitOfMeasure: samplingTarget?.unitOfMeasure
                ? SamplingTargetUnitOfMeasure[samplingTarget.unitOfMeasure]
                : "",
            value: samplingTarget?.value ? samplingTarget.value : 0,
            monitoredByUserName: "",
        };

        const monitoredByUserName = osmStore.orgUsers.find(
            (user) => user.id === tier?.samplingTarget?.monitoredByUserId,
        )?.userName;

        const unitOfMeasureLabel = `${formattedSamplingTarget?.value}${
            formattedSamplingTarget?.unitOfMeasure === "Percentage"
                ? "% of"
                : ""
        } calls ${formattedSamplingTarget?.timePeriod}`;

        return (
            <>
                {formattedSamplingTarget?.value ? (
                    <>
                        <LabelContainerGrid
                            item
                            xs={12}
                            lg={6}
                        >
                            <AcxInputLabel labelText="Sampling Target" />

                            <Tooltip title={unitOfMeasureLabel ?? ""}>
                                <Grid
                                    sx={{
                                        textOverflow: "ellipsis",
                                        overflow: "hidden",
                                        height: "15px",
                                        whiteSpace: "nowrap",
                                        lineHeight: "100%",
                                    }}
                                >
                                    {unitOfMeasureLabel}
                                </Grid>
                            </Tooltip>
                        </LabelContainerGrid>

                        <LabelContainerGrid
                            item
                            xs={12}
                            lg={6}
                        >
                            <AcxInputLabel labelText="Monitored By" />

                            <Tooltip title={monitoredByUserName ?? ""}>
                                <Grid
                                    sx={{
                                        textOverflow: "ellipsis",
                                        overflow: "hidden",
                                        height: "15px",
                                        whiteSpace: "nowrap",
                                        lineHeight: "100%",
                                    }}
                                >
                                    {monitoredByUserName}
                                </Grid>
                            </Tooltip>
                        </LabelContainerGrid>
                    </>
                ) : (
                    <>
                        <LabelContainerGrid
                            item
                            xs={12}
                            lg={6}
                        >
                            <AcxInputLabel labelText="Sampling Target" />
                            N/A
                        </LabelContainerGrid>

                        <LabelContainerGrid
                            item
                            xs={12}
                            lg={6}
                        >
                            <AcxInputLabel labelText="Monitored By" />
                            N/A
                        </LabelContainerGrid>
                    </>
                )}
            </>
        );
    });

export default SamplingTargetLabeledMetrics;
